import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { MappingCell, GetFlags, CellFunction } from '../../cells';

import { IEpxBFMgmt } from '../../../../../libs/apps/epxbfmgmt';

const IssuesCell: CellFunction<IEpxBFMgmt> = ({
  row: { original: session }
}) => {
  const flags = [];
  const getBMFlag = () => {
    return ['Not Enough Milk', 'intent-warning'];
  };
  const getLFlag = () => {
    return ['Latching/Pain', 'intent-warning'];
  };
  const getWFlag = () => {
    return ['Child Underweight', 'intent-warning'];
  };
  if (session.hasBreastMilkIssue) {
    flags.push(getBMFlag);
  }

  if (session.hasLatchingIssue) {
    flags.push(getLFlag);
  }

  if (session.hasWeightIssue) {
    flags.push(getWFlag);
  }

  return GetFlags(session, flags);
};

const EpxBFMgmtTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxBFMgmt>[] = [
    {
      Header: 'BF Status',
      id: 'breastfeeding',
      Cell: ResponseGuard(
        MappingCell('breastfeeding', {
          0: 'Exclusive BF',
          1: 'BF + Formula',
          2: 'Exclusive Formula'
        }) as CellFunction<IEpxBFMgmt>
      )
    },
    {
      Header: 'Issues',
      id: 'issues',
      Cell: ResponseGuard(IssuesCell)
    },
    {
      Header: 'Formula Reason',
      id: 'formulaReason',
      Cell: ResponseGuard(
        MappingCell('formulaReason', {
          0: 'Latching',
          1: 'Pain',
          2: "Doctor's Instruction",
          3: 'Other'
        }) as CellFunction<IEpxBFMgmt>
      )
    }
  ];
  return (
    <SessionTable<IEpxBFMgmt>
      url="/epxbfmgmt/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxBFMgmtTable;
